const log = console.log;

function emSetCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function emGetCookie(sKey) {
  if (!sKey) {
    return null;
  }
  return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1").replace('%', '')) || null;
}

/* Logbuy tracking */
if (
  document.referrer === 'https://www.mylogbuy.com/WebPages/Terms/DealTerms.aspx?dealId=32049&discountId=593301'
  ||
  document.referrer === 'https://www.mylogbuy.com/WebPages/ShowDeal/default.aspx?SupplierInfoId=18209'
  ||
  document.referrer.substring(0, 24).toLowerCase() === 'https://www.mylogbuy.com'
) {
  emSetCookie('em-mylogbuy', true, 1);

  fetch('/cart/update.js', {
    method: "POST",
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json;'
    },
    body: JSON.stringify({
      attributes: {
        _allowLogbuyDiscount: "true"
      }
    })
  })
}

function DOMready(callback) {
  if (document.readyState !== 'loading') callback();
  else document.addEventListener('DOMContentLoaded', callback);
}

DOMready(function () {
  function serialize(obj, prefix) {
    var str = [],
      p;
    for (p in obj) {
      if (obj.hasOwnProperty(p)) {
        var k = prefix ? prefix + '[' + p + ']' : p,
          v = obj[p];
        str.push((v !== null && typeof v === 'object') ?
          serialize(v, k) :
          encodeURIComponent(k) + '=' + encodeURIComponent(v));
      }
    }
    return str.join('&');
  }

  /* newsletter form fix scroll to form */
  if (document.querySelector('.shopify-challenge__container form')) {
    const challengeForm = document.querySelector('.shopify-challenge__container form');
    challengeForm.setAttribute('action', challengeForm.getAttribute('action') + '#newsletter_footer_form');
  }

  /* scroll-to-top */
  if (document.querySelector('.scroll-to-top')) {
    document.querySelector('.scroll-to-top').addEventListener('click', function () {
      window.scroll({top: 0, left: 0, behavior: 'smooth'});
    });
  }

  // theme - ajax add to cart
  if (document.querySelector('[action="/cart/add"]')) {
    document.querySelectorAll('[action="/cart/add"]').forEach(function ($form) {
      eventAddToCart($form);
    });
  }

  function eventAddToCart($form) {
    // log('eventAddToCart($form)', $form);

    $form.addEventListener('submit', function (e) {
      e.preventDefault();
      // log($form);

      let input = $form.getAttribute('action') + '.js';
      let init = {
        method: 'POST',
        body: {},
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest'
        }
      }

      // get product form data
      let formData = new FormData($form);
      let product = {};
      for (const pair of formData.entries()) {
        product[pair[0]] = pair[1];
      }
      // log(JSON.stringify(product));

      if ($form.getAttribute('action') === '/cart/change') {
        init.body = JSON.stringify({
          'id': $form.querySelector('[name="id"]').value,
          'quantity': $form.querySelector('[name="quantity"]').value
        });
      } else {
        let items = [];
        items.push(product);

        // add upsells
        document.querySelectorAll('.product-inline-upsells .product-inline-upsell-item').forEach(function ($el) {
          if (
            $el.querySelector('input[type=checkbox]').checked
            &&
            $el.querySelector('select option:checked')
            &&
            document.querySelector('.product-section').getAttribute('data-product-id')
            &&
            document.querySelector('.product-section').getAttribute('data-product-handle')
          ) {
            let productId = document.querySelector('.product-section').getAttribute('data-product-id');
            let productHandle = document.querySelector('.product-section').getAttribute('data-product-handle');

            try {
              if (document.querySelector('[data-klaviyo-item]')) {
                const klaviyoItem = JSON.parse(document.querySelector('[data-klaviyo-item]').innerText);
                if (klaviyoItem) {
                  productId = klaviyoItem.ProductID;
                  productHandle = klaviyoItem.URL.split('/').slice(-1)[0];
                }
              }
            } catch (error) {
              console.error(error);
            }

            items.push({
              'id': $el.querySelector('select option:checked').value,
              'quantity': 1,
              'properties': {
                '_product_inline_upsell_handle': productHandle,
                '_product_inline_upsell_id': productId,
              }
            });
          }
        });

        init.body = JSON.stringify({
          'items': items
        });
      }

      // add to cart
      fetch(input, init).then(function (response) {
        return response.json();
      }).then(function (data) {
        log(data.status);

        if (data.status) {
          let $msg = $form.querySelector('.product-added-to-cart');
          if ($msg && $msg.length !== 0) {
            $msg.innerHTML = theme.strings.cannotAddCart;

            setTimeout(function () {
              $msg.innerHTML = '';
            }, 3000);
          }

          return;
        }

        let $msg = $form.querySelector('.product-added-to-cart');
        if ($msg && $msg.length !== 0) {
          // add msg under add to cart
          $msg.innerHTML = theme.strings.addedToCart;

          setTimeout(function () {
            $msg.innerHTML = '';
          }, 3000);
        }

        // rebuild cart
        setTimeout(function () {
          document.dispatchEvent(new Event('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }, 400);

        // send klaviyo add to cart tracking
        const klaviyoItem = JSON.parse(e.target.querySelector('[data-klaviyo-item]').innerText);
        if (klaviyoItem) {
          if (e.target.querySelector('[data-klaviyo-item]')) {
            var _learnq = window._learnq || [];
            _learnq.push(['track', 'Added to Cart', klaviyoItem]);
            log('klaviyoItem', klaviyoItem);
          }
        }

        // cart popup
        if (!document.querySelector('.template-cart') && document.querySelector('.cart-popup')) {
          fetch(klaviyoItem.URL + '?t=' + Date.now() + '&view=ajax-cart-popup-products').then(function (response) {
            return response.text();
          }).then(function (html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // add product info
            if (doc.querySelector('.ajax-cart-popup-product')) {
              document.querySelector('.cart-popup-product').innerHTML = doc.querySelector('.ajax-cart-popup-product').innerHTML;

              const $cartPopupProduct = document.querySelector('.cart-popup-product');

              // add qty event
              new theme.QtySelector($cartPopupProduct.querySelector('.js-qty__wrapper'));

              // event add to cart
              eventAddToCart($cartPopupProduct.querySelector('[action="/cart/change"]'));
              $cartPopupProduct.querySelector('.js-qty__num').addEventListener('change', function () {
                $cartPopupProduct.querySelector('[action="/cart/change"]').dispatchEvent(new Event('submit'));
              });

              let adjustTimeout;
              $cartPopupProduct.querySelectorAll('.js-qty__adjust').forEach(function ($adjust) {
                $adjust.addEventListener('click', function () {
                  clearTimeout(adjustTimeout);
                  adjustTimeout = setTimeout(function () {
                    $cartPopupProduct.querySelector('[action="/cart/change"]').dispatchEvent(new Event('submit'));
                  }, 200);
                });
              })

              // add event
              if (document.querySelector('.cart-popup').querySelector('.js-cart-popup-close')) {
                document.querySelector('.cart-popup').querySelectorAll('.js-cart-popup-close').forEach(function ($close) {
                  $close.addEventListener('click', function () {
                    document.querySelector('.cart-popup').classList.remove('cart-popup--is-open');
                    if (document.querySelector('#CartDrawer')) {
                      document.querySelector('#CartDrawer').classList.remove('drawer--is-open');
                    }

                    document.documentElement.classList.remove('js-drawer-open', 'lock-scroll');
                  });
                });
              }
            }

            // add products
            if (doc.querySelector('.ajax-cart-popup-products')) {
              document.querySelector('.cart-popup-products').innerHTML = doc.querySelector('.ajax-cart-popup-products').innerHTML;
              document.querySelector('.cart-popup-products [data-aos="overflow__animation"]').classList.add('aos-init', 'aos-animate');

              // add event new products
              if (document.querySelector('.cart-popup-products [action="/cart/add"]')) {
                document.querySelectorAll('.cart-popup-products [action="/cart/add"]').forEach(function ($form) {
                  eventAddToCart($form);
                });
              }
            }

            // open cart popup + add background
            document.querySelector('.cart-popup').classList.add('cart-popup--is-open');
            document.documentElement.classList.add('js-drawer-open', 'lock-scroll');
          });

        } else if ($form.querySelector('.product-flying-cart')) {
          const flying = $form.querySelector('.product-flying-cart');

          flying.style.top = -flying.getBoundingClientRect().top + document.querySelector('.cart-link').getBoundingClientRect().top + 'px';
          flying.style.left = -flying.getBoundingClientRect().left + document.querySelector('.cart-link').getBoundingClientRect().left + 'px';
          flying.style.opacity = 1;

          setTimeout(function () {
            flying.style.transition = 'none';
            flying.style.opacity = 0;
            flying.style.top = '0px';
            flying.style.left = '0px';

            setTimeout(function () {
              flying.style.transition = 'all 1s ease-in-out';
            }, 100);
          }, 1100);

          // Check if cart page
          if (document.querySelector('.template-cart')) {
            window.location.reload();
          }
        }

        // add discount if found
        if ($form.parentElement.querySelector('[data-campaign-discount-code]')) {
          fetch('/discount/' + $form.parentElement.querySelector('[data-campaign-discount-code]').innerText.trim()).then(() => {
            log('discount:added');
          });
        } else if ($form.parentElement.parentElement.parentElement.querySelector('[data-campaign-discount-code]')) {
          fetch('/discount/' + $form.parentElement.parentElement.parentElement.querySelector('[data-campaign-discount-code]').innerText.trim()).then(() => {
            log('discount:added');
          });
        }
      }).catch(function (err) {
        log(err);

        let $msg = $form.querySelector('.product-added-to-cart');
        if ($msg && $msg.length !== 0) {
          $msg.innerHTML = theme.strings.errorCart;

          setTimeout(function () {
            $msg.innerHTML = '';
          }, 3000);
        }
      });
    });
  }

  /* cart change return shipping label to 1 */
  async function checkCartItems(forceCartBuild = false) {
    let updateData = {};
    updateData['updates'] = {};

    let changeDatas = [];
    let creditAmount = 0;
    let giftWrappingAmount = 0;

    document.querySelectorAll('.cart__item').forEach(function ($item) {
      const itemName = $item.querySelector('.cart__item-name').innerHTML.toLowerCase();
      const itemInput = $item.querySelector('[name="updates[]"]');
      let changeTmp = {};
      // log(itemName, itemInput);

      // Return shipping
      if (
        // Gaveindpakning
        itemName.includes('gaveindpakning') // da
      ) {
        itemInput.readOnly = true;
        itemInput.parentElement.querySelector('.js-qty__adjust--minus').disabled = true;
        itemInput.parentElement.querySelector('.js-qty__adjust--plus').disabled = true;

        // add class to item
        if (itemName.includes('gaveindpakning')) {
          let giftWraippingAmount = 0;

          // OLD
          const giftWrappingInput = document.querySelector('#gift-wrapping:checked');
          if (giftWrappingInput) {
            giftWraippingAmount = 1;
          }

          // NEW
          /*
          document.querySelectorAll('.product__gift_wrapping-selector input:checked').forEach(function ($checked) {
            giftWraippingAmount++;
          });
          */

          log(giftWraippingAmount);
          log(itemInput.value !== giftWraippingAmount.toString());
          if (itemInput.value !== giftWraippingAmount.toString()) {
            updateData['updates'][itemInput.getAttribute('data-id')] = giftWraippingAmount;
          }
        } else {
          if (itemInput.value !== '1') {
            updateData['updates'][itemInput.getAttribute('data-id')] = 1;
          }
        }
      } else if (
        // LØN
        itemName.includes('løn ') // da
        ||
        // Børnepenge
        itemName.includes('børnepenge ') // da
      ) {
        creditAmount = creditAmount + 1;
        if (creditAmount === 1) {
          if (itemInput.value !== '1') {
            updateData['updates'][itemInput.getAttribute('data-id')] = 1;
          }
        } else {
          updateData['updates'][itemInput.getAttribute('data-id')] = 0;
        }
      }

      // OLD
      const giftWrappingInput = document.querySelector('#gift-wrapping:checked');
      const giftWrappingExist = document.querySelector('.cart-product-type-gift-wrapping');
      if (!giftWrappingExist && giftWrappingInput) {
        changeTmp.properties = {
          '_gift_wrapping': 'Yes',
          [giftWrappingInput.getAttribute('data-name')]: giftWrappingInput.getAttribute('value')
        }
      }
      if (giftWrappingExist && !giftWrappingInput) {
        changeTmp.properties = {
          '_gift_wrapping': 'No',
        }
      }

      // NEW
      /*
      const giftWrappingInput = $item.querySelector('.product__gift_wrapping-selector input');
      if (giftWrappingInput) {
        if (giftWrappingInput.checked) {
          giftWrappingAmount++;
        }

        if (giftWrappingInput.getAttribute('data-default') !== 'Yes' && giftWrappingInput.checked) {
          changeTmp.properties = {
            '_gift_wrapping': 'Yes',
            [giftWrappingInput.getAttribute('data-name')]: giftWrappingInput.getAttribute('value')
          }
        }
        if (giftWrappingInput.getAttribute('data-default') === 'Yes' && !giftWrappingInput.checked) {
          changeTmp.properties = {
            '_gift_wrapping': 'No',
          }
        }
      }
      */

      if (Object.keys(changeTmp).length !== 0) {
        changeTmp.id = itemInput.getAttribute('data-id');
        changeDatas.push(changeTmp);
      }
    });

    if (
      (
        giftWrappingAmount !== 0 &&
        document.querySelector('.js-product-gift-wrapping') &&
        !document.querySelector('.cart-product-type-gift-wrapping')
      )
      ||
      (
        giftWrappingAmount !== 0 &&
        document.querySelector('.js-product-gift-wrapping') &&
        document.querySelector('.cart-product-type-gift-wrapping') &&
        parseInt(document.querySelector('.cart-product-type-gift-wrapping [name="updates[]"]').value) !== giftWrappingAmount
      )
    ) {
      updateData['updates'][document.querySelector('.js-product-gift-wrapping').getAttribute('data-variant-id')] = giftWrappingAmount;
    }

    let responseJson;

    // update data
    if (changeDatas.length !== 0) {
      for (const changeData of changeDatas) {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          body: JSON.stringify(changeData),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          }
        });

        responseJson = await response.json();
      }
    }

    if (Object.keys(updateData.updates).length !== 0) {
      // update quantity
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          body: JSON.stringify(updateData),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          }
        });

        responseJson = await response.json();
      } catch (err) {
        log(err);
      }
    }

    if (changeDatas.length !== 0 || Object.keys(updateData.updates).length !== 0) {
      // update cart + cart drawer
      setTimeout(() => {
        document.dispatchEvent(new Event('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: responseJson
          }
        }));
      }, 400);
    } else if (forceCartBuild) {
      setTimeout(function () {
        document.dispatchEvent(new Event('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }, 400);
    }
  }

  function cartProductEventListeners() {
    if (document.querySelector('.js-product-gift-wrapping')) {
      document.querySelectorAll('.product__gift_wrapping-selector input').forEach(($giftWrappingSelector) => {
        $giftWrappingSelector.addEventListener('click', function () {
          log('product__gift_wrapping-selector', this.checked);
          if (this.checked === true) {
            Shopify.Cart.GiftWrap.set();
          } else {
            Shopify.Cart.GiftWrap.remove();
          }
        });
      });
    } else {
      log('WARNING - Gift Wrapping Missing!');
    }

    document.querySelectorAll('.cart__item').forEach(function ($item) {
      $item.querySelectorAll('.cart__remove a').forEach(function ($removeBtn) {
        $removeBtn.addEventListener('click', function (e) {
          e.preventDefault();

          // custom product credit
          if ($item.classList.contains('cart-product-type-credit')) {
            Shopify.Cart.Credit.remove($item.getAttribute('data-key').split(':')[0]);
            return;
          }

          // custom product gift wrapping
          if ($item.classList.contains('cart-product-type-gift-wrapping')) {
            Shopify.Cart.GiftWrap.remove();
            return;
          }

          // update cart count
          fetch(e.target.getAttribute('href').replace('/cart/change', '/cart/change.js')).then(function (response) {
            return response.json();
          }).then(function (data) {
            setTimeout(function () {
              document.dispatchEvent(new Event('cart:build'));
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: {
                  cart: data
                }
              }));
            }, 400);
          });
        });
      });
    });
  }

  cartProductEventListeners();
  checkCartItems();

  document.addEventListener('cart:updated', function (data) {
    log('cart:updated', data);
    if (data.detail && data.detail.cart && data.detail.cart.item_count === 0) {
      location.reload();
      return;
    }

    // update cart count
    if (data.detail && data.detail.cart && data.detail.cart.item_count) {
      document.querySelector('.cart-link__bubble').classList.add('cart-link__bubble--visible');
      document.querySelector('.cart-link__bubble').innerHTML = data.detail.cart.item_count;

      cartCrossSells();
    } else {
      fetch('/cart.js').then(function (response) {
        return response.json();
      }).then(function (cart) {
        let data = {};
        data.detail = {};
        data.detail.cart = cart;
        log('cart:updated', data);
        document.querySelector('.cart-link__bubble').classList.add('cart-link__bubble--visible');
        document.querySelector('.cart-link__bubble').innerHTML = data.detail.cart.item_count;

        cartCrossSells();
      });
    }

    setTimeout(function () {
      checkCartItems();
      cartProductEventListeners();
    }, 500);
  });

  /* cart cross sells */
  function cartCrossSells() {
    if (document.querySelector('.cart-product-cross-sells-top') || document.querySelector('.cart-product-cross-sells-bottom')) {
      fetch('/cart?t=' + Date.now() + '&view=ajax-cross-sells').then(function (response) {
        return response.text();
      }).then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const cartProductCrossCellClassNames = [
          'cart-product-cross-sells-top',
          'cart-product-cross-sells-bottom'
        ];

        cartProductCrossCellClassNames.forEach(function ($className) {
          if (doc.querySelector('.ajax-' + $className)) {
            document.querySelector('.' + $className).innerHTML = doc.querySelector('.ajax-' + $className).innerHTML;

            if (document.querySelector('.' + $className + ' [data-aos="overflow__animation"]')) {
              document.querySelector('.' + $className + ' [data-aos="overflow__animation"]').classList.add('aos-init', 'aos-animate');
            }

            document.querySelectorAll('.' + $className + ' [action="/cart/add"]').forEach(function ($form) {
              eventAddToCart($form);
            });
          }
        });
      });
    }
  }

  /* cart gift wraps */
  Shopify.Cart = Shopify.Cart || {};
  Shopify.Cart.GiftWrap = {};

  /* Cart gift wrapping - NEW */
  Shopify.Cart.GiftWrap.set = function () {
    checkCartItems(true);
  }

  Shopify.Cart.GiftWrap.remove = function () {
    checkCartItems(true);
  }

  /* Cart gift wrapping - OLD */
  Shopify.Cart.GiftWrap.set = function () {
    const giftWrappingId = document.querySelector('.js-product-gift-wrapping').getAttribute('data-variant-id');

    var data = {};
    data['updates'] = {};
    data['updates'][giftWrappingId] = 1;
    data['attributes'] = {
      'gift-wrapping': 1
    };

    // update cart
    fetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      }
    }).then(function (response) {
      return response.json();
    }).then(function () {
      checkCartItems(true);
    }).catch(function (err) {
      log(err);
    });
  }

  /* Cart gift wrapping - OLD */
  Shopify.Cart.GiftWrap.remove = function () {
    const giftWrappingId = document.querySelector('.js-product-gift-wrapping').getAttribute('data-variant-id');

    var data = {};
    data['updates'] = {};
    data['updates'][giftWrappingId] = 0;
    data['attributes'] = {
      'gift-wrapping': 0
    };

    // update cart
    fetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      }
    }).then(function (response) {
      return response.json();
    }).then(function () {
      let gift = document.querySelector('[name="attributes[gift-wrapping]"][value="' + giftWrappingId + '"]');
      if (gift) {
        gift.checked = false
      }
      checkCartItems(true);
    }).catch(function (err) {
      log(err);
    });
  }

  if (document.querySelector('[name="attributes[gift-wrapping]"]')) {
    document.querySelector('[name="attributes[gift-wrapping]"]').addEventListener('click', function () {
      if (this.checked === true) {
        Shopify.Cart.GiftWrap.set();
      } else {
        Shopify.Cart.GiftWrap.remove();
      }
    });
  }

  /* cart credit */
  Shopify.Cart = Shopify.Cart || {};
  Shopify.Cart.Credit = {};
  Shopify.Cart.Credit.set = function (id) {
    var data = {};
    data['updates'] = {};

    // remove old credit
    var creditSelected = document.querySelectorAll('[name="attributes[credit]"]:checked');
    if (creditSelected.length >= 2) {
      var removeCredits = document.querySelectorAll('[name="attributes[credit]"]:checked');
      removeCredits.forEach(function ($credit) {
        if (id !== $credit.value) {
          $credit.checked = false;

          data['updates'][$credit.value] = 0;
          data['attributes'] = {'credit': false};
        }
      });
    }

    // add new credit
    data['updates'][id] = 1;
    data['attributes'] = {'credit': parseInt(id)};

    // update cart
    fetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      }
    }).then(function (response) {
      return response.json();
    }).then(function () {
      checkCartItems(true);
    }).catch(function (err) {
      log(err);
    });
  }

  Shopify.Cart.Credit.remove = function (id) {
    var data = {};
    data['updates'] = {};
    data['updates'][id] = 0;
    data['attributes'] = {'credit': false};

    // update cart
    fetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      }
    }).then(function (response) {
      return response.json();
    }).then(function () {
      let credit = document.querySelector('[name="attributes[credit]"][value="' + id + '"]');
      if (credit) {
        credit.checked = false
      }
      checkCartItems(true);
    }).catch(function (err) {
      log(err);
    });
  }

  document.querySelectorAll('[name="attributes[credit]"]').forEach(function ($credit) {
    $credit.addEventListener('click', function () {
      if (this.checked) {
        Shopify.Cart.Credit.set(this.value);
      } else {
        Shopify.Cart.Credit.remove(this.value);
      }
    });
  });

  // cart return freight add discount code
  const cartReturnFreight = document.querySelector('.cart__item--properties[data-rf-code]');
  console.log(cartReturnFreight);
  if (cartReturnFreight) {
    fetch('/discount/' + cartReturnFreight.getAttribute('data-rf-code'))
  }

  // mmenu light
  var mmenuLight = new MmenuLight(document.querySelector('#mmenu-light'), '(max-width: 1087px)');
  var mmenuDrawer = mmenuLight.offcanvas({
    position: 'left'
  });
  var navigator = mmenuLight.navigation({
    // selectedClass: 'Selected',
    // slidingSubmenus: true,
    // theme: 'dark',
    title: ''
  });
  navigator.openPanel(document.querySelector('#mmenu-light .mmenu-item.mmenu-active > .level-2'));

  document.querySelector('.js-drawer-open-nav').addEventListener('click', function (e) {
    e.preventDefault();
    mmenuDrawer.open();
  });

  Array.prototype.slice.call(document.querySelectorAll('#mmenu-light .level-1 > .mmenu-item')).forEach(function ($el) {
    $el.addEventListener('click', function () {
      Array.prototype.slice.call(document.querySelectorAll('#mmenu-light .level-1 > .mmenu-item')).forEach(function ($mm) {
        $mm.classList.remove('mmenu-active');
      });
      this.classList.add('mmenu-active');
      log(this.classList);
    });
  });

  Array.prototype.slice.call(document.querySelectorAll('#mmenu-light .mmenu-back')).forEach(function ($el) {
    $el.addEventListener('click', function () {
      navigator.openPanel(document.querySelector('#' + $el.getAttribute('data-back')));
    });
  });

  /* youtube lazyload */
  var youtube = document.querySelectorAll(".youtube-embedded");
  for (var i = 0; i < youtube.length; i++) {
    var image = new Image();

    // thumbnail image source
    var source = '';
    var className = '';
    if (youtube[i].dataset.source && youtube[i].dataset.source !== "") {
      source = youtube[i].dataset.source;
      image.className = 'lazyload';
      className = 'image-fit';
    } else {
      source = 'https://img.youtube.com/vi/' + youtube[i].dataset.embed + '/sddefault.jpg';
      image.className = 'lazyload';
      className = 'image-box';
    }

    // Load the image asynchronously
    image.src = source;
    if (youtube[i].dataset.alt) {
      image.alt = youtube[i].dataset.alt;
    }

    image.addEventListener('load', function () {
      youtube[i].querySelector('.youtube-image').classList.add(className);
      youtube[i].querySelector('.youtube-image').appendChild(image);
    }(i));

    youtube[i].addEventListener('click', function () {
      var iframe = document.createElement('iframe');

      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('src', 'https://www.youtube.com/embed/' + this.dataset.embed + '?rel=0&showinfo=0&autoplay=1');

      this.innerHTML = '';
      this.appendChild(iframe);
    });
  }

  // employee open popup
  var employees = document.querySelectorAll('.section-employee');
  for (var i = 0; i < employees.length; i++) {
    employees[i].addEventListener('click', function () {
      var modal = this.nextElementSibling;
      modal.classList.add('employee-active');
    });

    employees[i].nextElementSibling.querySelector('.section-employee-modal-close').addEventListener('click', function () {
      document.querySelector('.section-employee-modal.employee-active').classList.remove('employee-active');
    });
    employees[i].nextElementSibling.querySelector('.section-employee-modal-bg').addEventListener('click', function () {
      document.querySelector('.section-employee-modal.employee-active').classList.remove('employee-active');
    });
  }

  // auto open klaviyo popup on variant change
  document.addEventListener('variant:change', function (e) {
    if (
      (
        document.querySelector('.product-single__meta .variant-wrapper--dropdown select option:checked')
        &&
        document.querySelector('.product-single__meta .variant-wrapper--dropdown select option:checked').classList.contains('disabled')
      )
      ||
      (
        document.querySelector('.product-single__meta .variant-wrapper input:checked')
        &&
        document.querySelector('.product-single__meta .variant-wrapper input:checked').classList.contains('disabled')
      )
    ) {
      setTimeout(function () {
        document.querySelector('.btn.klaviyo-bis-trigger').click();
      }, 300);
    }
  });

  // auto open klaviyo popup on load if not in stock
  if (document.querySelector('.product-add-to-cart .add-to-cart:is(.disabled)')) {
    setTimeout(function () {
      document.querySelector('.btn.klaviyo-bis-trigger').click();
    }, 500);
  }

  /* product inline upsells */
  document.addEventListener('variant:change', function (e) {
    productInlineUpsellsAutoSelector(e.detail);
  });

  // change on load
  const variantSelected = document.querySelector('.variant-input input:checked');
  if (variantSelected) {
    productInlineUpsellsAutoSelector(variantSelected);
  }

  function productInlineUpsellsAutoSelector(variantSelected) {
    document.querySelectorAll('.product-inline-upsells .product-inline-upsell-item').forEach(function ($el) {
      let hasSelection = false;
      $el.querySelectorAll('select option').forEach(function (option) {
        if (!option.getAttribute('data-name')) {
          return;
        }

        if (hasSelection) {
          return;
        }

        const variantName = variantSelected.value.split('/')[0]; // fix L/XL -> L
        if (
          option.getAttribute('data-name') === variantSelected.value ||
          option.getAttribute('data-name') === variantName ||
          option.getAttribute('data-name').includes(variantName + '/') ||
          option.getAttribute('data-name').includes('/' + variantName)
        ) {
          $el.querySelectorAll('select option').forEach(function (op) {
            op.selected = false;
          });

          option.selected = true;
          hasSelection = true;
        }
      });
    });
  }

  /* filter drawer mod */
  function filterDrawerRedefine() {
    if (typeof theme.FilterDrawer.closeNow !== 'undefined') {
      return;
    }

    theme.FilterDrawer.isOpen = document.querySelector('#FilterDrawer').classList.contains('drawer--is-open');
    theme.FilterDrawer.closeNow = theme.FilterDrawer.close;
    theme.FilterDrawer.close = filterDrawerClose;
  }

  function filterDrawerClose(evt) {
    // log('filterDrawerClose', this.isOpen);

    if (!this.isOpen) {
      return;
    }
    // log('filterDrawerClose2');

    // Do not close if click event came from inside drawer
    if (!evt) {
      return;
    }

    if (evt.target.closest('.js-drawer-close')) {
      // Do not close if using the drawer close button
    } else if (evt.target.closest('.drawer')) {
      return;
    }

    if (evt.target.parentElement?.classList.contains('tag')) {
      initFilterDrawer();
      return;
    }

    // log('filterDrawerClose3');
    // log(evt);

    theme.FilterDrawer.closeNow();
  }

  document.addEventListener('drawerOpen.FilterDrawer', function () {
    log('drawerOpen.FilterDrawer');

    filterDrawerRedefine();

    // only fetch drawer content if empty
    if (document.querySelector('#CollectionGridFiltersFormAjax').childNodes.length !== 0) {
      return;
    }

    initFilterDrawer();
  });

  document.addEventListener('collection:reloaded', function () {
    log('collection:reloaded');

    filterDrawerRedefine();

    if ($collectionReload) {
      // hide price slider
      // document.querySelector('#FilterDrawer .price-range__display-wrapper').style.visibility = 'hidden';
      document.querySelector('#FilterDrawer .price-range__slider-wrapper').style.visibility = 'hidden';
    } else {
      // fetch on price slider change
      const $slider = document.querySelector('#FilterDrawer .price-range__slider');
      if ($slider && $slider.noUiSlider && typeof $slider.noUiSlider.destroy === 'function') {
        $slider.noUiSlider.on('change', function () {
          $collectionReload = true;
          initFilterDrawer();
        });
      }
    }

    // add events to product cards
    document.querySelectorAll('#CollectionAjaxContent [action="/cart/add"]').forEach(function ($form) {
      eventAddToCart($form);
    });
  });

  $collectionReload = false;

  function initFilterDrawer() {
    fetch(window.location.pathname + window.location.search + (window.location.search ? '&' : '?') + 'view=ajax-filter').then(function (response) {
      return response.text();
    }).then(function (html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      if (doc.querySelector('#CollectionGridFiltersFormAjax')) {
        // replace sidebar html
        document.querySelector('#CollectionGridFiltersFormAjax').innerHTML = doc.querySelector('#CollectionGridFiltersFormAjax').innerHTML;

        // sort xxxs xxs  xs s m l xl xxl xxxl
        const sizeList = [
          'XXXL',
          'XXL',
          'XL',
          'L',
          'M',
          'S',
          'XS',
          'XXS',
          'XXXS',
          'ONE-SIZE',
        ];

        sizeList.forEach(function (size) {
          document.querySelectorAll('#CollectionGridFiltersFormAjax .collection-sidebar__group').forEach(function ($group) {
            if ($group.querySelector('.collapsible-trigger-btn').innerHTML.trim().includes('Størrelse')) {
              const $tagList = $group.querySelector('.tag-list');

              $group.querySelectorAll('.tag-list .tag').forEach(function ($tag) {
                if ($tag.querySelector('.tag__text').innerHTML.trim() === size) {
                  $tagList.firstChild.after($tag);
                  return true;
                }
              });
            }
          });
        });

        // replace lang tags
        if (typeof replaceLanguageDefault !== 'undefined' && typeof replaceLanguageCurrent !== 'undefined' && replaceLanguageDefault.length !== 0 && replaceLanguageCurrent.length !== 0) {
          document.querySelectorAll('#CollectionGridFiltersFormAjax .tag-list .tag').forEach(function ($tag) {
            $tagText = $tag.querySelector('.tag__text').innerHTML.trim();
            if (replaceLanguageDefault.includes($tagText)) {
              replaceLanguageDefault.forEach(function ($default, $index) {
                if ($tagText === $default) {
                  // log($tagText, $default, replaceLanguageCurrent[$index]);
                  if (replaceLanguageCurrent[$index]) {
                    $tag.querySelector('.tag__text').innerHTML = replaceLanguageCurrent[$index];
                    return true;
                  }
                }
              });
            }
          });

          // replace lang tag headers
          document.querySelectorAll('#CollectionGridFiltersFormAjax .collection-sidebar__group').forEach(function ($group) {
            $groupHtml = $group.querySelector('.collapsible-trigger-btn').innerHTML;
            replaceLanguageDefault.some(function ($default, $index) {
              if ($groupHtml.includes($default)) {
                // log($groupHtml, $default, replaceLanguageCurrent[$index]);
                $group.querySelector('.collapsible-trigger-btn').innerHTML = $groupHtml.replace($default, replaceLanguageCurrent[$index]);
                return true;
              }
            });
          });
        }

        // check if collection reload
        $collectionReload = false;

        // reinit sidebar
        theme.sections.reinit('collection-grid');

        // reinit collection products
        // theme.reinitProductGridItem();
        theme.collapsibles.init();

        // fetch on input change
        document.querySelectorAll('#CollectionGridFiltersFormAjax .tag__input').forEach(function ($input) {
          $input.addEventListener('change', function () {
            $collectionReload = true;
            initFilterDrawer();
          });
        });

        // fetch on price slider change
        const $slider = document.querySelector('#FilterDrawer .price-range__slider');
        if ($slider && $slider.noUiSlider && typeof $slider.noUiSlider.destroy === 'function') {
          $slider.noUiSlider.on('change', function () {
            $collectionReload = true;
            initFilterDrawer();
          });

          document.querySelectorAll('.price-range-selector input').forEach(function ($input, $handle) {
            $input.addEventListener('change', function () {
              $slider.noUiSlider.setHandle($handle, this.value);
            });

            $input.addEventListener('keyup', function (e) {
              if (e.keyCode !== 13) {
                return false;
              }

              $slider.noUiSlider.setHandle($handle, this.value);
            });
          });
        }

        filterDrawerRedefine();
      }
    }).catch(function (error) {
      log(error);
    });
  }

  // mmenu drawer search close drawer and open search bar
  if (document.querySelector('#mmenu-light .site-header__search-form')) {
    document.querySelector('#mmenu-light .site-header__search-form').addEventListener('click', function () {
      mmenuDrawer.close();
      document.querySelector('.js-search-header').click();
    });
  }

  // shipping tracking section
  if (document.querySelector('.shipping-tracking-form')) {
    document.querySelectorAll('.shipping-tracking-form').forEach(function ($form) {
      $form.addEventListener('submit', async function (e) {
        e.preventDefault();

        $form.querySelector('.form-success').classList.add('hide');
        $form.querySelectorAll('.form-error').forEach(function ($error) {
          $error.classList.add('hide');
        });

        try {
          const response = await fetch('https://public.molly-tech.dk/api/order-tracking-info', {
            method: 'POST',
            body: JSON.stringify(Object.fromEntries(new FormData($form))),
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          // check for http error
          if (!response.ok) {
            $form.querySelector('.error').classList.remove('hide');
            return;
          }

          // format json
          const data = await response.json();
          log(data);

          // check for errors
          if (data.error) {
            log('.error-' + String(data.error_id).charAt(0) + '0');
            $form.querySelector('.error-' + String(data.error_id).charAt(0) + '0').classList.remove('hide');
            return;
          }

          // show button
          $form.querySelector('.form-success').classList.remove('hide');
          $form.querySelector('.form-success a').setAttribute('href', data.tracking_url);
        } catch (err) {
          log(err);
        }
      });
    });
  }

  // shipping refund section
  if (document.querySelector('.shipping-refund-form')) {
    function formReset($form) {
      $form.querySelector('.order-success').classList.remove('hide');

      $form.querySelector('.return-success-complaint-message a').removeAttribute('href');
      $form.querySelector('.return-success-complaint-message').classList.add('hide');

      $form.querySelector('.return-success-gift-card-message a').removeAttribute('href');
      $form.querySelector('.return-success-gift-card-message').classList.add('hide');

      $form.querySelector('.return-success-gift-card-only-message a').removeAttribute('href');
      $form.querySelector('.return-success-gift-card-only-message').classList.add('hide');

      $form.querySelector('.return-success-refund-message-button').removeAttribute('href');
      $form.querySelector('.return-success-refund-message').classList.add('hide');

      $form.querySelector('.return-success-benefit-message a').removeAttribute('href');
      $form.querySelector('.return-success-benefit-message').classList.add('hide');

      $form.querySelectorAll('.form-error').forEach(function ($error) {
        $error.classList.add('hide');
      });
    }

    document.querySelectorAll('.shipping-refund-form').forEach(function ($form) {
      $form.querySelectorAll('input').forEach(function ($input) {
          $input.addEventListener('blur', async function (e) {
            e.preventDefault();

            formReset($form);

            $input.value = $input.value.replaceAll(' ', '');

            // check if all inputs are filled
            let allFilled = true;
            $form.querySelectorAll('input').forEach(function ($inputCheck) {
              if ($inputCheck.value === '') {
                allFilled = false;
              }
            });

            if(!allFilled) {
              return;
            }

            try {
              const response = await fetch('https://public.molly-tech.dk/api/order-return-info?modeV2=1', {
                method: 'POST',
                body: JSON.stringify(Object.fromEntries(new FormData($form))),
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                }
              });

              // check for http error
              if (!response.ok) {
                $form.querySelector('.error').classList.remove('hide');
                return;
              }

              // format json
              const data = await response.json();
              // log(data);

              // check for errors
              if (data.error) {
                log('.error-' + String(data.error_id).charAt(0) + '0');
                $form.querySelector('.error-' + String(data.error_id).charAt(0) + '0').classList.remove('hide');
                return;
              }

              if (data.return_allowed) {
                $form.querySelector('.return-success-refund-message-button').setAttribute('href', data.return_url);
                $form.querySelector('.return-success-refund-message').classList.remove('hide');
              }

              if (
                data.return_allowed ||
                data.return_allow_gift_card ||
                data.return_allow_gift_card_only ||
                data.return_benefit
              ) {
                $form.querySelector('.order-success').classList.add('hide');
              } else {
                $form.querySelector('.error-105').classList.remove('hide');
              }

              if (data.complaint_url) {
                $form.querySelector('.return-success-complaint-message a').setAttribute('href', data.complaint_url);
                $form.querySelector('.return-success-complaint-message').classList.remove('hide');

                if (data.return_allow_gift_card) {
                  if (data.return_allow_gift_card_only) {
                    $form.querySelector('.return-success-gift-card-only-message a').setAttribute('href', data.return_allow_gift_card_url);
                    $form.querySelector('.return-success-gift-card-only-message').classList.remove('hide');
                  } else {
                    $form.querySelector('.return-success-gift-card-message a').setAttribute('href', data.return_allow_gift_card_url);
                    $form.querySelector('.return-success-gift-card-message').classList.remove('hide');
                  }
                }

                if (data.return_benefit && data.return_benefit_url) {
                  $form.querySelector('.return-success-benefit a').setAttribute('href', data.return_benefit_url);

                  if (data.return_benefit_shipping) {
                    $form.querySelector('.return-success-benefit-shipping').innerHTML = $form.querySelector('.return-success-benefit-shipping').getAttribute('data-html').replace('{{ shipping }}', data.return_benefit_shipping + '%')
                  } else {
                    $form.querySelector('.return-success-benefit-shipping').innerHTML = '';
                  }

                  if (data.return_benefit_percentage) {
                    $form.querySelector('.return-success-benefit-percentage').innerHTML = $form.querySelector('.return-success-benefit-percentage').getAttribute('data-html').replace('{{ percentage }}', data.return_benefit_percentage + '%')
                  } else {
                    $form.querySelector('.return-success-benefit-percentage').innerHTML = '';
                  }

                  if (data.return_benefit_amount) {
                    $form.querySelector('.return-success-benefit-amount').innerHTML = $form.querySelector('.return-success-benefit-amount').getAttribute('data-html').replace('{{ amount }}', theme.Currency.formatMoney(data.return_benefit_amount * 100, theme.settings.moneyFormat));
                  } else {
                    $form.querySelector('.return-success-benefit-amount').innerHTML = '';
                  }

                  $form.querySelector('.return-success-benefit').classList.remove('hide');
                }
              } else {
                // $form.querySelector('.error-106').classList.remove('hide');
              }
            } catch (err) {
              log(err);
            }
          });
      });
    });
  }

  // page index / frontpage content
  if (document.querySelector('.page-index')) {
    document.querySelector('.page-index > a').addEventListener('click', () => {
      if (document.querySelector('.page-index').hasAttribute('data-read-more')) {
        document.querySelector('.page-index').removeAttribute('data-read-more');
      } else {
        document.querySelector('.page-index').setAttribute('data-read-more', '');
      }
    });
  }

  // product color selector
  if (document.querySelector('.product-single__colors')) {
    const $title = document.querySelector('.product-single__colors').getAttribute('data-title').trim();
    const $color = document.querySelector('.product-single__colors').getAttribute('data-color').trim();

    fetch('/search/suggest.json?' + serialize({
      'q': $title,
      'resources': {
        'type': 'product',
        'limit': 99,
        'options': {
          'unavailable_products': 'last',
          'fields': 'title'
        }
      }
    })).then(function (response) {
      return response.json();
    }).then(function (data) {
      let innerHtml = '';
      let counter = 0;

      data.resources.results.products.forEach(($product) => {
        const title = $product.title.trim().replace('  ', ' ')
        if (title.includes($title + ' - ')) {
          let colorClass = '';
          if (title.includes(' - ' + $color)) {
            colorClass = 'product-single__color-active';
          }
          innerHtml += '<a href="' + $product.url.split('?')[0] + '" class="' + colorClass + '"> <img loading="lazy" height="' + $product.featured_image.height + '" width="' + $product.featured_image.width + '" src="' + theme.Images.getSizedImageUrl($product.featured_image.url, 'medium') + '" alt="' + $product.featured_image.alt + '"></a>';
          counter++;
        }
      });

      if (counter > 1) {
        document.querySelector('.product-single__colors').classList.remove('hide');
        document.querySelector('.product-single__colors').innerHTML = innerHtml;
      }
    });
  }

  // youtube model
  const youtubeModal = document.querySelector('.youtube-modal');
  if (youtubeModal) {
    document.querySelector('.youtube-modal-btn').onclick = function () {
      youtubeModal.style.display = 'block';

      if (document.querySelector('.youtube-modal .youtube-play-button')) {
        document.querySelector('.youtube-modal .youtube-play-button').click();
      } else {
        document.querySelector('.youtube-modal .youtube-embedded iframe').setAttribute('src', 'https://www.youtube.com/embed/' + document.querySelector('.youtube-modal .youtube-embedded').getAttribute('data-embed') + '?rel=0&showinfo=0&autoplay=1');
      }
    }

    document.querySelector('.js-youtube-modal-close').onclick = function () {
      youtubeModal.style.display = 'none';

      document.querySelector('.youtube-modal .youtube-embedded iframe').setAttribute('src', '');
    }

    window.onclick = function (event) {
      if (event.target === youtubeModal) {
        youtubeModal.style.display = 'none';

        document.querySelector('.youtube-modal .youtube-embedded iframe').setAttribute('src', '');
      }
    }
  }
});